var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 227 209.9",
    style: {
      enableBackground: "new 0 0 227 209.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#5CBFBB;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFE3CE;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FCFCFC;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#E2BBA1;}\n\t.st4{opacity:0.6;}\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FBC2CD;}\n\t.st6{opacity:0.9;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#F7DDCB;}\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#FCDA77;}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#D69E21;}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#424242;}\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:#5392E0;}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#133AA0;}\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:#FE8A9C;}\n\t.st14{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:#1A1D1E;}\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:#B8CCFF;}\n\t.st17{fill:#133AA0;}\n\t.st18{fill-rule:evenodd;clip-rule:evenodd;fill:#11318B;}\n\t.st19{fill:#11318B;}\n\t.st20{opacity:0.7;}\n\t.st21{opacity:0.5;}\n\t.st22{fill-rule:evenodd;clip-rule:evenodd;fill:#5394E0;}\n\t.st23{fill:#FFFFFF;}\n\t.st24{fill-rule:evenodd;clip-rule:evenodd;fill:#4D9ACC;}\n\t.st25{fill-rule:evenodd;clip-rule:evenodd;fill:#A07060;}\n\t.st26{fill-rule:evenodd;clip-rule:evenodd;fill:#935D4A;}\n\t.st27{fill-rule:evenodd;clip-rule:evenodd;fill:#333333;}\n\t.st28{fill-rule:evenodd;clip-rule:evenodd;fill:#5E2C16;}\n\t.st29{fill-rule:evenodd;clip-rule:evenodd;fill:#FF8736;}\n\t.st30{fill-rule:evenodd;clip-rule:evenodd;fill:#E87528;}\n\t.st31{fill-rule:evenodd;clip-rule:evenodd;fill:#EFB289;}\n\t.st32{fill-rule:evenodd;clip-rule:evenodd;fill:#71CBDB;}\n\t.st33{fill-rule:evenodd;clip-rule:evenodd;fill:#DB976A;}\n\t.st34{fill-rule:evenodd;clip-rule:evenodd;fill:#A06652;}\n\t.st35{fill-rule:evenodd;clip-rule:evenodd;fill:#1C1C1C;}\n\t.st36{fill-rule:evenodd;clip-rule:evenodd;fill:#EFEFEF;}\n\t.st37{fill-rule:evenodd;clip-rule:evenodd;fill:#E5A87F;}\n\t.st38{fill-rule:evenodd;clip-rule:evenodd;fill:#7A5DA7;}\n\t.st39{fill-rule:evenodd;clip-rule:evenodd;fill:#329B93;}\n\t.st40{fill-rule:evenodd;clip-rule:evenodd;fill:#2C1B29;}\n\t.st41{fill-rule:evenodd;clip-rule:evenodd;fill:#804A2F;}\n\t.st42{fill-rule:evenodd;clip-rule:evenodd;fill:#703D28;}\n\t.st43{fill-rule:evenodd;clip-rule:evenodd;fill:#B7371D;}\n\t.st44{fill-rule:evenodd;clip-rule:evenodd;fill:#47A59C;}\n\t.st45{fill-rule:evenodd;clip-rule:evenodd;fill:#FFEADE;}\n\t.st46{fill-rule:evenodd;clip-rule:evenodd;fill:#EFD3C5;}\n\t.st47{fill-rule:evenodd;clip-rule:evenodd;fill:#F57C90;}\n\t.st48{fill-rule:evenodd;clip-rule:evenodd;fill:#E86B87;}\n\t.st49{fill-rule:evenodd;clip-rule:evenodd;fill:#CF8464;}\n\t.st50{fill-rule:evenodd;clip-rule:evenodd;fill:#824321;}\n\t.st51{fill-rule:evenodd;clip-rule:evenodd;fill:#E5AE13;}\n\t.st52{fill-rule:evenodd;clip-rule:evenodd;fill:#93452C;}\n\t.st53{fill-rule:evenodd;clip-rule:evenodd;fill:#2B2B2B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VB--404-Copy-5",
    transform: "translate(-616.000000, -299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(616.242518, 299.046533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-62",
    transform: "translate(0.000000, 92.149634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-58",
    transform: "translate(1.528974, 1.529127)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.3,
    y: -1.8,
    transform: "matrix(0.9899 -0.1415 0.1415 0.9899 -5.9828 8.1362)",
    className: "st0",
    width: 95.8,
    height: 95.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(51.320027, 31.959020)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.908143, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st1",
    d: "M10.4,24c-0.2-0.1-5.5-7.8-5.5-7.8l2.4-7.3c0,0,5.7-5.2,5.9-5.4c0.2-0.2,12.8-3.7,12.8-3.7 l11.8,8.4l0.8,8.7l-9.1,7.2c0,0-4.1,2.4-11.1,1.8C16,25.7,13.4,25.1,10.4,24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1_",
    className: "st2",
    d: "M18.5,24.4c0,0-5.9-1.2-5.8-4.3c0.1-3.2-2-1.2-3.3-2C8,17.4,6.7,13.7,11,14.9 c0,0,0.4-0.8-0.2-3.5s2.6,0.1,4.9-1.6C18,8,17.9,4.8,19.5,5.6c1.6,0.8,2.8,2.1,4.9,0.5s3-1.2,3.5,0.1 c0.5,1.3,1.7,2.2,3.5,2.2s-2.7,2.1,1.1,5c0,0,2.2-1.6,2.4,0.6c0.2,2.2-1,2.6-2.8,2.5c0,0,0.2,4.8-5.9,7.7l1.2,4.4 c0,0,8.7,2.2,10.5-3.7c0,0,0.2-2.7,3.2-2.6s6.2-4.6,1.3-9.9c0,0-0.7-1.2,0.7-2.9c1.4-1.8,0.3-4.6-1.9-5.6s0.8-4.4-2.5-8 c-3.3-3.6-5-0.2-7.9-2.4s-6.7-2.1-9.6-0.3s-1.6,2.5-6.8,2.5S6-2.7,5.9-0.1s0.4,3.8-2.2,3.9c-2.6,0.2-5,3.7-2.7,7 c2.2,3.3,2.5,4.7,1.5,6.8s-0.4,3.6,2,4.1c2.4,0.5,2.1,0.8,2.3,2.9c0.2,2.2,2.1,5.7,11.5,3.1L18.5,24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2_",
    className: "st3",
    d: "M21.9,18.2c-0.3,0-0.5-0.1-0.7-0.3c-0.6-0.7,0.3-2.4,0.3-2.6l0.2,0.1 c-0.2,0.5-0.8,1.9-0.4,2.3c0.2,0.2,0.5,0.2,1.1,0.1l0.1,0.3C22.3,18.1,22.1,18.2,21.9,18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3_",
    className: "st2",
    d: "M13.3,12.6c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.2-0.1-0.4,0-0.5c0.8-0.7,2.8-1.8,4.5-0.7 c0.2,0.1,0.2,0.3,0.1,0.5c-0.1,0.2-0.3,0.2-0.5,0.1c-1.7-1.1-3.6,0.6-3.6,0.6C13.5,12.5,13.4,12.6,13.3,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4_",
    className: "st2",
    d: "M24.6,11.1c-0.1,0-0.2-0.1-0.2-0.1c-0.2-0.1-0.2-0.4,0-0.5c0,0,2.1-2.2,4.6-0.4 c0.2,0.1,0.2,0.3,0.1,0.5c-0.1,0.2-0.3,0.2-0.5,0.1c-2-1.4-3.6,0.3-3.7,0.3C24.8,11.1,24.7,11.1,24.6,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5_",
    className: "st3",
    d: "M17.4,20.9l-0.1-0.3c0.4-0.1,0.7-0.3,0.8-0.7c0.3-0.6,0-1.3,0-1.4l0.3-0.1 c0,0.1,0.3,0.9,0,1.6C18.2,20.5,17.9,20.8,17.4,20.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6_",
    className: "st3",
    d: "M26.5,19.5c-1.1-0.1-1.4-1.2-1.4-1.7h0.3c0,0.1,0.1,1.4,1.2,1.5V19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7_",
    className: "st3",
    d: "M21.9,21c-0.4,0-0.8-0.1-1.1-0.1c-1.4-0.3-2.5-1-2.5-1.1l0.2-0.2c0.2,0.1,4.1,3,7-0.7 l0.2,0.2C24.5,20.6,23.1,21,21.9,21z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    transform: "translate(26.474759, 23.961181)",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 1.9,
    cy: -7.3,
    rx: 1.9,
    ry: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Oval_1_",
    transform: "translate(13.419428, 25.480433)",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9953 -9.650521e-02 9.650521e-02 0.9953 0.6927 0.1534)",
    className: "st5",
    cx: 1.9,
    cy: -7.1,
    rx: 1.9,
    ry: 1
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8_",
    className: "st1",
    d: "M18.4,31.3l1.1-7.3c0,0,3.3,1,7.2-0.7l2.7,10.4l2,5.9l-6.7,6.8l-8.9-5.8l-1.6-5L18.4,31.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_9_",
    transform: "translate(19.277563, 32.230818)",
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M0.2-7.8c0,0,3.7,1.7,7.6-0.3l0.4,1.5c0,0-5.3,1.8-8.1,0.2L0.2-7.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10_",
    className: "st8",
    d: "M46.9,41.7c-3.2-6.9-7.4-11.2-17-11.9l-5.5,9.8L16.2,32c0,0-7.3,2.3-8.9,6.6 C6.4,40.9,3,52.5,0,63l53.7-7.7C51,50.2,48.4,45,46.9,41.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11_",
    className: "st9",
    d: "M42,42.8l1,14.1l2.8-0.4C44.3,52.8,42.9,48.3,42,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12_",
    className: "st9",
    d: "M8.1,61.9C8.1,54.2,8.3,46,8.3,46s-1.4,7.7-3,14.5c-0.2,0.6-0.3,1.2-0.5,1.9L8.1,61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13_",
    className: "st10",
    d: "M26.1,13.7c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1,0-0.2,0.1-0.3c0.1-0.1,2.2-1,3.8-0.1 c0.1,0.1,0.1,0.2,0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-1.4-0.9-3.4,0.1-3.4,0.1C26.1,13.7,26.1,13.7,26.1,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14_",
    className: "st10",
    d: "M15.2,14.9c-0.1,0-0.2-0.1-0.2-0.1c-0.1-0.1,0-0.2,0.1-0.3c0.1-0.1,2.1-1.2,3.8-0.3 c0.1,0.1,0.1,0.2,0.1,0.3c-0.1,0.1-0.2,0.1-0.3,0.1C17.2,13.7,15.3,14.8,15.2,14.9C15.2,14.9,15.2,14.9,15.2,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15_",
    className: "st3",
    d: "M33.8,16l-0.2-0.2c1.2-1.2,1.2-1.5,1.1-1.5c-0.1-0.2-0.7-0.1-1,0L33.7,14 c0.2-0.1,1-0.3,1.3,0.2C35.1,14.4,34.8,15,33.8,16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16_",
    className: "st3",
    d: "M11.5,17.9L11.5,17.9c-0.4-0.1-0.9-0.4-1.3-1.1c-0.3-0.5-0.4-0.8-0.2-1 c0.3-0.4,1.2-0.1,1.4,0L11.3,16c-0.3-0.1-0.9-0.2-1.1-0.1c-0.1,0.1-0.1,0.2,0.2,0.7c0.4,0.8,0.8,0.9,1,0.9 c0.2,0,0.3-0.1,0.3-0.1l0.2,0.2C12,17.7,11.8,17.9,11.5,17.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1_",
    transform: "translate(9.095592, 23.006446)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path_17_",
    className: "st5",
    points: "39.3,58.4 35.3,66.2 37.6,72.6 41.3,72.1  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18_",
    className: "st11",
    d: "M37.4,72.6l-0.1-0.5l-0.5-20.6l-3.1-7.1l-16.4-3.6l-4.1-5.1c0,0-9.9,2.4-11.7,7l2.5,24.9 l0.4,9.9L37.4,72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19_",
    className: "st12",
    d: "M32.8,39.1c0,0,4.1,0.8,5.6,6.6c1.5,5.9,2.2,14.7,2.2,14.7L37.7,62L32.8,39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20_",
    className: "st5",
    d: "M16.3,17.5c0,0-3.5-0.4-3.5-3.6s3.5-5.9,6-6s5.9-8.3,5.9-8.3h13.6v3.8 c0,0,1.3,14.8-3.6,20.8s-6.3,3.7-6.3,3.7l-0.6,11.3l-3.1,5.9l-8.8-9l3-11.7C18.9,24.4,16.8,21.3,16.3,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21_",
    className: "st13",
    d: "M28.2,28.4c0,0-4.3,0.1-7.6-3.3s-3.5-8.5-0.8-11c0,0,4.5-4.4,4.7-10.6l-8.9,7.1 c0,0-2.5-0.9-2.8,3.3c0,0-0.5,2.9,3.5,3.6c0,0,0.7,4.7,2.6,6.9l-3,11.7l6.9,7.1c0,0-2.1-16.1,5.4-13.9V28.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22_",
    className: "st13",
    d: "M35.4,4.4c-0.9,0-2.3-0.1-3-0.8c-0.8-0.9-2.4-1-2.4-1.1c-0.1,0-0.2-0.1-0.2-0.2 c0-0.1,0.1-0.2,0.2-0.2c0.1,0,1.7,0.2,2.6,1.2c0.7,0.7,2.6,0.7,3.3,0.7c0.1,0,0.2,0.1,0.2,0.2s-0.1,0.2-0.2,0.2 C36.1,4.3,35.8,4.4,35.4,4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23_",
    className: "st14",
    d: "M10.8,1.2c0,0-0.8-3.8,2.1-3.5c2.9,0.3,5,0.4,8-2.4s12.6-5.3,17.5-1.4 c5,3.8,2.9,7.3,1.4,8.4c0,0,0.1,5.3-1.4,5.9l-0.2-4.7c0,0-4.9-0.3-6.5-0.9S25.4,1,24.2,4.3c-1.3,3.3-4,11.3-5.8,8.8 s-2.9-3.1-4.8-1.6c-1.9,1.4-3,0.7-2.9-2.3C10.8,6.2,10.8,1.2,10.8,1.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_2_",
    className: "st15",
    cx: 35.7,
    cy: 17.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_3_",
    className: "st15",
    cx: 27.8,
    cy: 15.2,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24_",
    className: "st14",
    d: "M24.5,8c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,2.1-2.2,4.6-2.3 c0,0,0,0,0.1,0c1.2,0,2.2,0.5,3.2,1.4c0.1,0.1,0.1,0.3,0,0.4c-0.1,0.1-0.3,0.1-0.4,0C30.9,6.2,30,5.8,29,5.8 c-2.2,0-4.2,2.1-4.2,2.1C24.6,8,24.5,8,24.5,8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25_",
    className: "st14",
    d: "M38.4,10.2c-0.1,0-0.2-0.1-0.3-0.2c-0.4-0.8-0.9-1.3-1.5-1.4c-1-0.3-2,0.2-2,0.2 c-0.1,0.1-0.3,0-0.4-0.1c-0.1-0.1,0-0.3,0.1-0.4c0.1,0,1.2-0.7,2.5-0.3c0.8,0.2,1.4,0.8,1.8,1.7c0.1,0.1,0,0.3-0.1,0.4 C38.5,10.2,38.4,10.2,38.4,10.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26_",
    className: "st13",
    d: "M35.1,6c-0.8,0-1.8-0.2-2.6-0.9c-1.4-1-2.2-0.7-2.2-0.7c-0.1,0.1-0.2,0-0.3-0.1 s0-0.2,0.1-0.3c0.1,0,1-0.4,2.7,0.8c1.8,1.3,3.5,0.7,3.6,0.5c0.1-0.1,0.2,0,0.3,0.1c0.1,0.1,0,0.2-0.1,0.3 C36.1,5.9,35.7,6,35.1,6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27_",
    className: "st5",
    d: "M15.2,16.5c-0.1-0.1-1.6-1.2-1.5-2.6c0.1-0.8,0.5-1.4,1.5-2l0.3,0.5 c-0.8,0.4-1.2,1-1.3,1.6c-0.1,1.2,1.3,2.2,1.3,2.2L15.2,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28_",
    className: "st14",
    d: "M23.4,20.4c0,0,0.8,0.6,1.5,0.2c0.7-0.4,3.6-1.9,5.3-0.1c0,0,2-0.7,2.7,0.6 s0.4,1.9,1.7,1.3c0,0-0.5,2.4-2.9,2.5s-2.2-2.5-2.2-2.5s-0.5,1.7-3.1,1.3C23.8,23.2,23.5,21.5,23.4,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29_",
    className: "st16",
    d: "M39.9,69.2c-1.9-2-1.5-9.7-2.3-20.3s-7.9-12.5-7.9-12.5c-0.3-1.3-1.7-2.6-1.7-2.6 c-0.3,7.9-4.3,7.9-4.3,7.9l-1.3-3l-4.9,4.5c-1.2,1.9-8.4,3.8-8.4,3.8l-2.7,3.2L9.9,54c2.1,3,2.1,11.7,3.5,19.3 c0.2,0.9,0.4,1.9,0.7,2.8l26.3-3.8L39.9,69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30_",
    className: "st12",
    d: "M28.7,65.1c-0.2-0.8-0.5-1.6-0.8-2.5c-0.2-0.4-0.3-0.8-0.6-1.2c-0.2-0.4-0.4-0.7-0.7-1.1 c-0.7-1.5-1-3.3-1.2-5s-0.4-3.4-0.5-5.1c-0.1-1.7-0.2-3.4-0.2-5.1c1-0.9,1.9-1.9,2.6-3c0.4-0.5,0.7-1.2,1-1.8s0.5-1.3,0.7-1.9 l0,0c-0.2,0.7-0.4,1.3-0.7,1.9s-0.7,1.2-1,1.7c-0.8,1.1-1.6,2.1-2.7,2.9l-0.1,0.1v0.1c-0.1,3.5,0.1,6.9,0.6,10.4 c0.3,1.7,0.5,3.4,1.3,5c0.2,0.4,0.4,0.8,0.7,1.1c0.3,0.3,0.4,0.8,0.6,1.2c0.3,0.8,0.6,1.6,0.8,2.4c0.8,2.8,1.3,5.6,1.6,8.5 h0.1C29.9,70.8,29.5,67.9,28.7,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st17",
    d: "M28.6,54c2-0.3,4.2-0.6,6.4-0.8h0.1v0.1c0.3,1,0.5,1.9,0.7,2.9c0.2,1,0.5,1.9,0.8,2.9l0,0 l0,0l-2.4,3l-0.1,0.1L34.1,62c-1.3-0.5-2.6-1.1-3.9-1.6l-0.1-0.1v-0.1c-0.3-1.1-0.5-2.1-0.8-3.2L28.6,54z M28.7,54l0.9,3.2 c0.3,1,0.6,2.1,0.8,3.1l-0.1-0.1c1.3,0.5,2.6,1.1,3.9,1.6l-0.2,0.1l2.5-2.9V59c-0.2-1-0.5-1.9-0.8-2.9 c-0.3-0.9-0.5-1.9-0.8-2.8l0.1,0.1C33,53.6,30.9,53.8,28.7,54z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_4_",
    className: "st12",
    cx: 25.6,
    cy: 45.9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_5_",
    className: "st12",
    cx: 26.1,
    cy: 54.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_6_",
    className: "st12",
    cx: 32.3,
    cy: 55,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_7_",
    className: "st12",
    cx: 29.7,
    cy: 64.5,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31_",
    className: "st12",
    d: "M35.3,55c-0.4,0.3-0.8,0.5-1.2,0.8c-0.4,0.3-0.8,0.4-1.3,0.7l0.1-0.1 c0.1,0.5,0.2,0.9,0.3,1.4c0.2,0.4,0.3,0.9,0.4,1.4s0.2,0.9,0.3,1.4c0.1,0.5,0.2,0.9,0.2,1.4l0,0c-0.2-0.4-0.3-0.9-0.4-1.4 s-0.3-0.9-0.4-1.4s-0.2-0.9-0.3-1.4c-0.1-0.5-0.2-0.9-0.3-1.4v-0.1l0.1-0.1c0.4-0.3,0.8-0.5,1.2-0.7 C34.4,55.3,34.8,55.1,35.3,55L35.3,55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32_",
    className: "st12",
    d: "M29.2,55.4c0.3,0,0.6,0.1,0.9,0.1c0.2,0.1,0.3,0.1,0.4,0.2c0.2,0.1,0.3,0.1,0.4,0.1 c0.6,0.1,1.2,0.2,1.8,0.5l0,0c-0.7,0-1.2-0.2-1.8-0.4c-0.2-0.1-0.3-0.1-0.4-0.2c-0.2-0.1-0.3-0.1-0.4-0.1 C29.8,55.7,29.5,55.6,29.2,55.4L29.2,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33_",
    className: "st5",
    d: "M2.9,66.3l1.6,11l2-0.3c0.5-4.8,1.5-10.9,1.5-10.9L2.9,66.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_34_",
    className: "st14",
    points: "15.3,32.3 13.3,35.7 19.1,45.9 22.5,38.7  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35_",
    className: "st12",
    d: "M30.7,44.2c0,0,1.4-4-1.9-5.8L28,40.5L30.7,44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36_",
    className: "st18",
    d: "M3.3,69.2c2.5-0.3,4.9-1.6,4.9-1.6s0.4-2.8,1.4-10S9,43.6,5.4,42.2c-3.6-1.4-5.1,3-5.1,3 L0,45.9L3.3,69.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37_",
    className: "st13",
    d: "M32.4,20.5h-2.7v-0.3h2.4C32,10.9,33.8,9.1,34,9.1l0.2,0.2c0,0-1.9,1.9-1.8,11.1 L32.4,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "st19",
    d: "M41.5,14.6c-0.5-0.5-5.8-2.4-7-2.5s-2.7-0.2-3.7-0.7c-1-0.4-6.7-1.5-6.7-1.5l-7.6,1.1l1,1 l6-0.4c-0.3,1.5-0.7,3.5-0.1,4.4c1,1.5,5.3,1.4,6.2,1.3c0.9-0.2,1.7-3.9,2.4-3.8c0.7,0.2,0.3,3.3,0.3,4.2 c-0.1,0.9,4.7,2.1,5.9,2.1s2.2-4.1,2.2-4.1C41.7,15.5,41.5,14.6,41.5,14.6z M29,16.2c-1.1,0.1-4.9,0.1-4.5-1.9 c0.4-2,0.4-2.7,0.4-2.7l5.5,1.1C30.4,12.7,30.1,16.1,29,16.2z M38,18.5c-0.8,0.3-4.9-0.6-4.7-1.9c0.3-1.3,0.8-3.1,0.8-3.1 l5.6,1.6C39.8,15.2,38.8,18.2,38,18.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_38_",
    transform: "translate(10.898395, 1.587715)",
    className: "st20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M0,6.7c1.3-0.4,2.5-1,3.6-1.8c1.1-0.8,2.1-1.7,2.7-2.9s1.4-2.4,2.4-3.3c0.5-0.5,1-0.9,1.6-1.3 c0.6-0.3,1.2-0.7,1.8-0.9c1.3-0.5,2.6-0.7,4-0.7c1.4,0,2.7-0.1,4-0.3c1.3-0.2,2.6-0.5,3.8-1.1c1.2-0.5,2.4-1.3,3.1-2.5l0,0 l0,0c-0.7,1.2-1.8,2-3,2.7c-1.2,0.6-2.5,1-3.9,1.2c-1.3,0.2-2.7,0.3-4.1,0.3c-1.3,0-2.7,0.2-3.9,0.6 c-0.7,0.2-1.3,0.5-1.8,0.8C9.6-2.1,9.1-1.7,8.6-1.2C7.6-0.3,7,0.9,6.4,2.1c-0.7,1.2-1.6,2.2-2.8,3C2.6,5.8,1.3,6.3,0,6.7 L0,6.7L0,6.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 3.066885)",
    className: "st21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M0-1.9c0.9-0.1,1.8-0.3,2.6-0.6C3.5-2.8,4.3-3.2,5-3.8c0.7-0.5,1.3-1.2,1.9-2 c0.3-0.3,0.5-0.8,0.8-1.2c0.2-0.4,0.4-0.8,0.7-1.2l0,0l0,0C8.1-7.2,7.7-6.3,7.1-5.6c-0.5,0.8-1.2,1.4-2,1.9 S3.6-2.8,2.7-2.4C1.9-2,0.9-1.8,0-1.9C0-1.9,0-1.9,0-1.9L0-1.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.695644, 2.464461)",
    className: "st21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M0,6.9c0.9-0.9,1.8-2,2.6-3c0.8-1,1.4-2.2,1.9-3.5c0.2-0.6,0.3-1.3,0.7-1.9C5.4-2,5.9-2.5,6.4-2.9 C7-3.3,7.6-3.6,8.2-3.8C8.8-4,9.4-4.2,10.1-4.2c0.7-0.1,1.3-0.1,2,0c0.7,0.1,1.3,0.2,2,0.4c1.3,0.3,2.6,0.3,3.9,0.2 c1.3-0.1,2.6-0.5,3.7-1.2s1.8-1.9,1.9-3.2l0,0l0,0c-0.1,1.3-0.8,2.6-1.9,3.4s-2.4,1.2-3.7,1.3c-1.3,0.2-2.7,0.1-4-0.3 C13.3-3.8,12.7-4,12-4.1c-0.7-0.1-1.3-0.1-2-0.1C8.7-4,7.4-3.6,6.4-2.8C5.9-2.4,5.4-1.9,5.1-1.3S4.7-0.1,4.5,0.5 C4.2,1.8,3.5,2.9,2.6,4C1.9,5.1,1,6.1,0,6.9C0,7,0,7,0,6.9C0,7,0,7,0,6.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.328136, 8.817294)",
    className: "st21"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M1.5-8.1c0.1,0.2-0.1,0.4-0.2,0.5C1.3-7.5,1.2-7.5,1.2-7.5S1-7.4,0.9-7.3C0.7-7,0.3-6.9,0-7l0,0l0,0 c0.3-0.3,0.5-0.4,0.9-0.4c0.1,0,0.2-0.1,0.2-0.1c0.1-0.1,0.1-0.2,0.1-0.2C1.3-7.9,1.4-8,1.5-8.1L1.5-8.1L1.5-8.1L1.5-8.1z"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    className: "st23",
    d: "M14,103.5L0,5.9l97.6-14l14,97.6L14,103.5z M3.1,8.2l13.1,92.2l92.2-13.1L95.3-5L3.1,8.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-63",
    transform: "translate(168.249717, 158.752515) rotate(21.000000) translate(-168.249717, -158.752515) translate(113.088653, 103.591451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-61",
    transform: "translate(1.502471, 1.502222)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_1_",
    className: "st24",
    points: "-2.9,5.9 90.9,-7.5 104.3,86.3 10.5,99.7  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2_",
    transform: "translate(20.215336, 26.110358)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.528211, -0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39_",
    className: "st25",
    d: "M5.3,16.4L3.4,23l1.9,4.1l6.9-1l1.1-3l0-8.5l1-4.7c0,0,2.9,0.5,3.2-1.9S15.7,5.7,15,6.1 l-0.3-6.1l-7-2.9L0.1-2l-0.4,8.6c0,0,4.3,4.2,4.3,4.4C4.1,11.3,5.3,16.4,5.3,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40_",
    className: "st26",
    d: "M13.4,19.6c0,0-2.5-2.8-8.4-1.8l0.4-1.4l8-3L13.4,19.6L13.4,19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41_",
    className: "st27",
    d: "M3.8,0.6c0,0-5,0.9-6.1-2.7S-1-8.6,2.4-7.2s5,2.4,10,2c5-0.4,5.8,6.8,2.7,11.2 c0,0,2,8.5-3.5,10.1S-1,16.9-2.6,11.6s2.9-7,4.8-6.5C4,5.6,5.4,5.8,7,7c1.6,1.2,5.2,1,6.2-1.5S11.8-1,7.8-0.2 C3.8,0.6,3.8,0.6,3.8,0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42_",
    className: "st28",
    d: "M5.2,5.6L5.2,5.6C3.1,5.6,3,4.9,3,4.9V4.8l1.5-2.5c0-0.1,0.1-0.1,0.1,0 c0.1,0,0.1,0.1,0,0.1L3.1,4.9C3.2,5,3.4,5.5,5.2,5.6C5.2,5.6,5.2,5.6,5.2,5.6C5.2,5.6,5.2,5.6,5.2,5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43_",
    className: "st14",
    d: "M7,8.8c0,0-2.3-1.7-4.3-1.1C2.6,7.6,3.3,13.1,7,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44_",
    className: "st28",
    d: "M16.1,8.9C16.1,8.9,16,8.9,16.1,8.9C16,8.8,16,8.8,16,8.7c0.4-0.3,0.6-0.5,0.6-0.9 c0-0.6-1-1.1-1-1.1c-0.1,0-0.1-0.1-0.1-0.1s0.1-0.1,0.1-0.1s1.1,0.5,1.1,1.2C16.9,8.2,16.6,8.5,16.1,8.9 C16.1,8.9,16.1,8.9,16.1,8.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_8_",
    className: "st27",
    cx: 8,
    cy: 2.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_9_",
    className: "st27",
    cx: 2.1,
    cy: 2.5,
    r: 1
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_45_",
    className: "st27",
    points: "69.7,62.3 70.1,56.6 42.4,55.9 41,66.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46_",
    className: "st29",
    d: "M71.2,20.5l-7.2,0c0,0,1,3.8-4,4.1c-5,0.3-4.7-1.9-5.3-3.7c0,0-13.6-2.1-29.6,1.2 C14.7,24.1-2.9,39-2.9,39l6.6,5C3.7,44,15,27.9,46,31.8c0,0-5.5,19.1-5,25.3c0,0,11.3,4.3,29.9,0.9c0,0,2.4-22,1.9-24.2 c0,0,6.5,12.7,8.5,26.9l2.9-0.4L79.4,27C77.2,23.9,74.5,21.6,71.2,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47_",
    className: "st30",
    d: "M47.2,38.9c0,0-1.5,15.1,1.5,17C48.7,55.9,43.4,56.8,47.2,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48_",
    className: "st30",
    d: "M51.2,47.4c0,0-2,7,11.9,7.6C63.1,55,48.2,55.2,51.2,47.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_49_",
    className: "st30",
    points: "72.8,33.7 68.2,58.4 70.9,57.9  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50_",
    className: "st30",
    d: "M46,31.8l0.4-1.7l-16.5,0v1.7C29.9,31.8,41.9,31.1,46,31.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3_",
    transform: "translate(15.063815, 11.458693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51_",
    className: "st31",
    d: "M39.6,20.5c0,0-3.7-13.3-6.3-15.4c-2.6-2.1-7.4-4.4-7.4-4.4s-0.2-1,1.8-0.2 s2.2-0.3,0.3-2.2c-1.9-1.9-3.5-5.6-1.9-4.1c1.6,1.5,4.9,5,0.7-1.4c0,0,0.4-1.3,3,2.9c0,0,1.5,1.3-0.7-3.2c0,0,1.2-0.7,2.5,4 c0,0,0.9-0.5,0.1-3.1c0,0,0.5-1.2,1.5,3.2c1,4.4,6.2,8.8,6.2,8.8s7.7,8.6,8.7,14.9l0.1,1.2L39.6,20.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52_",
    className: "st31",
    d: "M-2.4,70.6c0,0-0.7,3.4,5.5,3.2c6.2-0.2,5.9,4,5.9,6.4c0,0,2.3,2.3,1-4.1 c0,0,0.8-1,1.1,3.8c0,0,2.1,1.8,0.3-4.2c0,0,0.9,0.6,2.2,3.6c0,0,1.6-0.1-1.2-4.7c0,0,2.1,2.5,2.6,2.7 c0.5,0.2,0.1-1.7-2.1-5.1c0,0-1.1-1.5,0.6-3.3c1.7-1.8-0.3-2.1-1-1.1c-0.8,1-2.2,2.9-4.8,1c-2.6-1.8-3.6-2.7-5-2.6 C2.5,66.3-0.6,65.6-2.4,70.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53_",
    className: "st31",
    d: "M15.3,41.2c0,0,1.5-1.5,2.3-2.5l-6-8.3l-1.4-1.2L7.3,24l1.5-1.8l-1.6-3.3l6.1-3.7l5.2,0.3 c0,0,3.4,3.2,5.3,8.4c1.7,4.6,1.4,2.9-0.4,5.2c-1.8,2.3-0.1,2.9,1.5,6.3l3.7,0.3l-0.8,10.1l-12.6-3.1L15.3,41.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54_",
    className: "st8",
    d: "M6.4,23.6c0,0,0.2,2.1,0.3,3.2c0.2,2.8,4.9,4.3,3,5.8c0,0-0.2,3.2,5,2.2l-6.3-9.8 c0,0-0.6-1.8,1.7-1.1c2.3,0.8,3.8,0.9-0.7-3.8l-2.3,0.4L6.4,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55_",
    className: "st32",
    d: "M6.4,23.6c0,0-5.7-4.5-4-7.4s4.4-7.7,11.5-4.1l1.8,1.6l0.9,2.5 C16.7,16.3,11.2,17,6.4,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56_",
    className: "st18",
    d: "M20.7,6.4c0,0,5.6-1-0.5,10.6c0,0-2.7-1.8-10.8,3.2C9.4,20.3,14.3,7.3,20.7,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57_",
    className: "st18",
    d: "M45.4,80c-0.8-4.2-1.6-7.3-2.6-8.6l-24.1,7.9c0,0-0.5,1.8-1.4,4.7L45.4,80z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58_",
    className: "st14",
    d: "M-2.8,66.1c0,0-0.6-3,1.9-10.2s10-12.4,16.1-14.7l10.5,3.1l0.8-9.6c0,0,11.6-4,12.8-12.5 L38,22.3l-0.2-3.2L50,20.9c0,0-0.1,3.4-1.2,4.8L48,25.7c0,0-1.3,9-5,12.7c-3.7,3.7-6.2,8.3-5,11.8c1.2,3.5,8.3,22.6,8.3,22.6 s-3.3,4.6-10.7,6.1l-3-3.2l-0.2,4.1c0,0-7.1,3.6-14.6,2c0,0,1.8-15.2-5.8-22.9l-6.3,6.1c0,0,0.6,1.1,0.6,2.9 c0,0-0.4-1.6-4.9-1.6c0,0-3.6,0.8-3.7,5.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59_",
    className: "st33",
    d: "M20.8,24.6c-0.1,0-0.1,0-0.1-0.1c-0.1-0.1,0-0.2,0.1-0.2c0,0,0.5-0.3,1.1-1.2 c0.1-0.1,0.1-0.1,0-0.2c-0.2-0.8-2.5-2.1-3.4-2.5c-0.1-0.1-0.1-0.1-0.1-0.2s0.1-0.1,0.2-0.1c0.3,0.2,3.2,1.7,3.5,2.7 c0.1,0.2,0,0.3-0.1,0.4C21.4,24.2,20.9,24.6,20.8,24.6C20.8,24.6,20.8,24.6,20.8,24.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60_",
    className: "st34",
    d: "M16.2,25.5c0,0,2.2,1.3,5.1,0.7C21.4,26.2,20.6,30.9,16.2,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61_",
    className: "st33",
    d: "M10.1,26.3C10.1,26.3,10.1,26.3,10.1,26.3c-1-1.2-1-1.6-0.9-1.7c0.2-0.3,1.1,0.3,1.4,0.4 c0.1,0,0.1,0.1,0,0.1c0,0.1-0.1,0.1-0.1,0c-0.5-0.3-1.1-0.6-1.2-0.5c-0.1,0.1-0.1,0.3,0.9,1.5C10.2,26.2,10.2,26.2,10.1,26.3 C10.2,26.3,10.1,26.3,10.1,26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62_",
    className: "st35",
    d: "M13.2,21.5c-0.1,0-0.1,0-0.1-0.1s-0.1-0.1,0-0.2c1.5-1.7,2.7-0.7,2.7-0.7 c0.1,0.1,0.1,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0C15.5,20.7,14.6,20,13.2,21.5L13.2,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63_",
    className: "st35",
    d: "M18.6,20c-0.1,0-0.1,0-0.1-0.1c-0.1-0.1-0.1-0.1,0-0.2c1.5-1.7,2.7-0.7,2.7-0.7 c0.1,0.1,0.1,0.1,0,0.2c-0.1,0.1-0.1,0.1-0.2,0C20.8,19.1,19.9,18.4,18.6,20C18.6,20,18.6,20,18.6,20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64_",
    className: "st36",
    d: "M25.8,44.3l3.5,15.6c0.6,2.6,1.1,5.2,1.7,7.8c0.5,2.6,1.1,5.2,1.6,7.9l0,0l0,0 c-0.6-2.6-1.2-5.2-1.8-7.8c-0.6-2.6-1.1-5.2-1.7-7.8L25.8,44.3L25.8,44.3L25.8,44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65_",
    className: "st36",
    d: "M11.9,58.8c0,0,7,6,5.8,22.9C17.8,81.7,24.8,61.8,11.9,58.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66_",
    className: "st36",
    d: "M29.2,48.9c0,0,5.3,17.8,8.6,20.6C37.7,69.5,30.7,54.5,29.2,48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67_",
    className: "st37",
    d: "M22.8,29.9c0,0-1.1,2.4-6.1,1.4l8.2,4C24.8,35.3,22.8,32.6,22.8,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68_",
    className: "st36",
    d: "M4.6,64.5c0,0-5.4-1.4-6.6,1.5C-2,66,1.3,63.8,4.6,64.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69_",
    className: "st36",
    d: "M4.6,63.5c0,0-1.4-2.2-5.6-0.6C-1,62.8,2.3,62.4,4.6,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70_",
    className: "st36",
    d: "M40.3,22.3c0,0,4.6,0.3,6.6,2.2C46.9,24.6,41.9,23.5,40.3,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71_",
    className: "st36",
    d: "M39.7,23.6c0,0,5.3,0.9,6.9,3.1C46.6,26.8,45.1,23.7,39.7,23.6z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    className: "st23",
    d: "M0.2,8.5l13,91.1l91.1-13l-13-91.1L0.2,8.5z M10.9,102.8L-2.9,6.3L93.6-7.5L107.4,89 L10.9,102.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-60",
    transform: "translate(32.469838, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_2_",
    className: "st38",
    points: "32.6,3.4 129.8,12.3 120.9,109.4 23.8,100.5  "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(0.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4_",
    transform: "translate(23.159993, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72_",
    className: "st39",
    d: "M72.5,85.6c0,0,6.3,15.8,25.4,7.1l1.8-20.3L72.5,85.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_",
    className: "st23",
    d: "M99.9,100.9l-1.4-0.1L0,91.9L9.1-8.1L109,1l-0.1,1.4L99.9,100.9z M3,89.4l94.4,8.6 L106,3.6L11.6-5L3,89.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73_",
    className: "st40",
    d: "M95.8,24.8c0,0,1.3,0.4,3.6-2.8c2.3-3.2,1.3-8.9-2.3-8.8c-3.5,0.1-8.1,1.5-9.6-4.3 C86.1,3.2,80.1-3.8,71.1-2.8c-9,0.9-7.7,14.2-17.3,9.4c-9.6-4.8-18.2,0.6-19.5,2.8c-1.3,2.2-2.6,5.7,3.5,7.7 c6.1,2.1,3,5-2.6,7.7c-5.6,2.7-9.4,13.3-2.8,19c6.6,5.6,20.6,7.9,33.8-1.3s12.4-16,23.2-15.4L95.8,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74_",
    className: "st41",
    d: "M99.8,71.7l-13.5,9.5c0,0,5.5,8.6,11.3,14.3L99.8,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75_",
    className: "st41",
    d: "M86.2,82.8c0,0-12.5,3.7-11.7,9.5c0.2,1.4,0.7,2.6,1.3,3.7l16.6,1.5 c-0.2-0.1-0.3-0.2-0.4-0.3C89.8,96,86.2,82.8,86.2,82.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76_",
    className: "st41",
    d: "M90.9,17.4c0,0,3.5-1.7,5.6,2.1s0.6,9.5-6.8,9.5c0,0-1.2,1.3-1.1,4.7c0,0,7.8-3,12.7-3.3 c4.9-0.3,10.5-4.7,15-5.7c4.5-1.1,19.2-1.7,25.2,1.4l-1.7,0.3c0,0,6.5,4.3,4.7,3.7c-1.8-0.6-9.1-4.8-12.8-4.3 c-3.6,0.4-7.5,1.2-17.8,5.2s-14.5,6.5-16.4,7c-1.8,0.5-3.1,0.4-3.1,0.4l-6.6,7l-4.5-10.3l2.6-8.5C86,26.7,84.9,19.6,90.9,17.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77_",
    className: "st41",
    d: "M76.9,44.8c0,0-3.5,16.4-5.5,18.9c-2,2.5-8.2,11.1-9.6,13.1c-1.4,2-3.2,4.5-5,5.4 s-6.1,3.7-4.1,3.4s2.5-0.9,2.5-0.9s-4.6,5.7-3,4.8c1.6-0.8,4.3-2.9,5.3-3.9c0.9-1,3.5-3.3,4.3-4.1c0.8-0.7,13-12.4,13-12.4 l3-9.6l3.1-7.4l-2.4-4.7L76.9,44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78_",
    className: "st0",
    d: "M85.1,55.4c0.1-2,3.7-7.1,5.8-10c2.1-2.9,3.5-7,3.5-7c-9.9,0.8-5.7-4.7-5.7-4.7 c-5.9,0.1-10.2,4.1-10.2,4.1c-4.4,3.8-2.1,7.5-1.3,11.5s-1.9,9.5-4.2,18.5s-1.8,15.3-1.8,15.3c1.4,8.9,3.1,11.8,4.1,12.8 l0.8,0.1c-0.2-6.7,13.4-14.4,23.2-19.9l1.7-18.1C92.4,56.2,85.1,55.4,85.1,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79_",
    className: "st42",
    d: "M89.7,29.1c0,0-2.2-0.3-2.7-1.7l1.7,6.4C88.7,33.8,88.5,30.5,89.7,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80_",
    className: "st35",
    d: "M92.2,20.8c-0.1,0-0.1,0-0.1-0.1c0,0-0.7-0.6-1.3-0.6c-0.3,0-0.6,0.2-0.9,0.4 c-0.1,0.1-0.1,0.1-0.2,0c-0.1-0.1-0.1-0.1,0-0.2c0.3-0.3,0.7-0.5,1.1-0.6h0.1c0.8,0,1.5,0.7,1.5,0.7c0.1,0.1,0.1,0.2,0,0.2 C92.3,20.8,92.2,20.8,92.2,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81_",
    className: "st35",
    d: "M96.7,21.7c-0.1,0-0.1-0.1-0.1-0.1c-0.2-0.4-0.4-0.6-0.7-0.7c-0.4-0.1-0.8,0.3-0.8,0.3 c-0.1,0.1-0.2,0.1-0.2,0c-0.1-0.1-0.1-0.2,0-0.2c0,0,0.4-0.5,1-0.4c0.3,0.1,0.7,0.3,0.9,0.8C96.8,21.6,96.8,21.7,96.7,21.7 C96.7,21.7,96.7,21.7,96.7,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82_",
    className: "st28",
    d: "M94,23.4C94,23.4,93.9,23.4,94,23.4c-0.1-0.1-0.1-0.1,0-0.2c0,0,0.5-0.2,0.7-0.6 c0.2-0.3-0.6-0.9-1.1-1.3c-0.1,0-0.1-0.1,0-0.1c0-0.1,0.1-0.1,0.1,0c0.2,0.1,1.4,1,1.1,1.5C94.5,23.2,94,23.4,94,23.4L94,23.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83_",
    className: "st40",
    d: "M96.8,20.2c-0.1,0-0.1,0-0.1-0.1c-0.9-1.3-2.3-0.6-2.4-0.5s-0.2,0-0.2-0.1 c-0.1-0.1,0-0.2,0.1-0.2c0,0,1.7-0.9,2.8,0.6c0.1,0.1,0.1,0.2-0.1,0.2C96.9,20.2,96.9,20.2,96.8,20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84_",
    className: "st40",
    d: "M92.5,19.4c-0.1,0-0.1,0-0.1-0.1s-1.6-1.6-3.2-0.2c-0.1,0.1-0.2,0.1-0.2,0S88.9,19,89,19 c1.8-1.5,3.6,0.2,3.6,0.2C92.6,19.2,92.6,19.3,92.5,19.4L92.5,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85_",
    className: "st14",
    d: "M89.6,24.2c0,0,2.6,3.1,5.2,1C94.8,25.2,92.6,24.1,89.6,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86_",
    className: "st43",
    d: "M89.6,24.2c0,0,2.5,4.6,5.2,1C94.8,25.2,92,27.1,89.6,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87_",
    className: "st43",
    d: "M89.6,24.2c0,0,2.5-0.8,3.1-0.4s0.4-0.3,0.9,0.1c0.4,0.4,1.2,1.2,1.2,1.2 S92.1,24,89.6,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88_",
    className: "st44",
    d: "M87.9,36.7v13c0,0,5.3-6.4,6.5-11.3C94.4,38.5,89.3,39.5,87.9,36.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89_",
    className: "st44",
    d: "M74.5,72.9c0,0-3.1,22.1,2.6,14.4S71.8,96.4,74.5,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90_",
    className: "st44",
    d: "M78.9,67.7c0,0-6,5.5,0.4,15C79.3,82.7,76.8,78,78.9,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91_",
    className: "st44",
    d: "M91.5,62.8c1.4-0.1,5.2,0.1,9.1,0.3l0.1-0.7C96.2,62.3,92.5,62.6,91.5,62.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5_",
    transform: "translate(0.000000, 10.646432)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92_",
    className: "st29",
    d: "M29.3,0c0,0,1.4,1.9,4.3,0.7c3-1.2,7.6-2.9,11-1.9l9,16.4c0,0-3.7,7.5-9.9,3.4 s-9.1-3.4-9.1-3.4s3.4-1.4,5.7-1.3C40.3,13.8,30.3,13.2,29.3,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93_",
    className: "st45",
    d: "M36.1,74.8c0,0-0.1,2-0.1,4.7L62.7,82l-1.5-6.1L36.1,74.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94_",
    className: "st45",
    d: "M42.9,33.9l3.1,4.7l3.8,16c0,0,14.3,6.9,16.8,7.8c2.6,0.8,5.6,1.7,7,2.7 c1.4,0.9,4.7,0.8,5.9,0.3c1.2-0.5-2.1-0.9-2.1-0.9c5.7-2.3,4-3.4,3.8-2.9s-2.4,1.2-2.4,1.2c-2.3-1.8-2.2,0.4-6.6-0.6 c-4.3-1.1-12.5-8.4-14.1-9.9S56.9,50,56.9,50l1.4-9.8l1.8-4.1c0,0-0.4-4.8-2.1-7.1c-1.6-2.3-1.9-5.5-2-10.4s4.7-6.9,4.7-6.9 l-0.5-8.4l-2-4l-9.3,4.3c-3,9.2-0.9,11.9,0,12.6c0.9,0.7,2.9,0,2.9,0c-0.6,3.4-2.2,8.1-2.2,8.1c-3-0.1-15.1,6.4-19.5,9.2 L29.8,39L42.9,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95_",
    className: "st46",
    d: "M51.9,16.3c0,0,1.2-0.2,2.3-0.9L50.5,22C50.5,22,51.9,17.6,51.9,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96_",
    className: "st29",
    d: "M58.8,2.6c0,0-3.5,5.1-8.5,4.6s-4.8-4.7-7.4-6.6c-2.6-1.8-5.5-6.9,0.4-8.8 c0,0-3.2,2.2,0.2,4c3.3,1.8,5-1,8.4-1.1c3.4-0.1,8.6,0.8,8.5,7.1L58.8,2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97_",
    className: "st29",
    d: "M59.5,9.5c0,0-3.2-2.6-1.2-6.1c2-3.6,8.3-1.2,8.5,2s0.6,9.1-6.3,10.9s-5.5,1.6-5.5,1.6 s0.6-3.2,2.3-3.3c0,0-2.4-5.1-4.2-1.5C53.1,12.9,51.5,8.1,59.5,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98_",
    className: "st47",
    d: "M48.8,24.5c0,0,1.6,2.5,0.7,5.5c-0.8,3-2.7,8.1-6.5,4l2.7,9c0,0-2.9,6.2-1.7,7.1 c1.2,0.9,1.2,0.9,1.2,0.9s-8.1,3.1-10.9,6.2c-2.8,3.1-9,12.3-13.8,13c0,0,10.1,2.8,12.9,4.7c2.8,1.9,9.6,6.8,18.3,4.1 s12-1.7,12-1.7L53,53.3c0,0,2-0.6,1.7-2.1s-0.9-6.7,2.2-9c3.1-2.3,6.1-6.7,2.1-11.6c0,0-2.3,4.5-5,1.4 c-4.1-4.7-4.2-7.6-4.2-7.6L48.8,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99_",
    className: "st3",
    d: "M50.3,12.5l-0.4-0.3c-0.5-0.3-0.7-0.9-0.4-1.5l0.8-1.4l0.2,0.1l-0.8,1.4 c-0.2,0.4-0.1,0.9,0.3,1.1l0.4,0.3L50.3,12.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_10_",
    className: "st10",
    cx: 49.4,
    cy: 8.3,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_11_",
    className: "st10",
    cx: 53.5,
    cy: 8.9,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100_",
    className: "st3",
    d: "M49.7,14c0,0,2.1-0.1,3.6-0.6C53.4,13.4,50.7,17.2,49.7,14z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_12_",
    className: "st3",
    cx: 51.5,
    cy: 10.7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_13_",
    className: "st3",
    cx: 48,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_14_",
    className: "st3",
    cx: 52.5,
    cy: 11,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_15_",
    className: "st3",
    cx: 48.7,
    cy: 11.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_16_",
    className: "st3",
    cx: 51.8,
    cy: 11.7,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval_17_",
    className: "st3",
    cx: 48.7,
    cy: 10.3,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101_",
    className: "st48",
    d: "M47.1,34.8v8c0,0-3.6,5.7-0.7,6.9l0.7,2.3L44,49.9c0,0-0.9-0.4-0.1-2.3 c0.8-1.9,1.8-4.7,1.8-4.7l-2.7-9C42.9,33.9,45,36.7,47.1,34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102_",
    className: "st48",
    d: "M48.1,52.6c0,0,3.6-0.4,4.9,2.3C53,54.8,51.1,52.9,48.1,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103_",
    className: "st48",
    d: "M34,61.2c0,0-9.3,6.5-5.4,9.3C28.7,70.5,27.5,66.2,34,61.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104_",
    className: "st48",
    d: "M47.4,70.2c0,0,8.5,1.6,12.4,4.3C59.7,74.5,53.7,72.6,47.4,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105_",
    className: "st45",
    d: "M30.2,33.6c0,0-12.8,6.7-19,7.9S0,42.1,0,42.1s-0.7,0.8,5.2,1.6c6,0.8-5.1,1.2-1.4,1.8 c3.7,0.6,8.2-1.8,8.2-1.8L29.7,39l2.8-4.6L30.2,33.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6_",
    transform: "translate(51.604071, 19.238654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106_",
    className: "st27",
    d: "M39.8,25.5c0.9-1.8-0.8-8.4-0.8-8.4l-21.7,0.7l0.2,17.3c0,0-3.6,21.5-3.8,27.9 c-0.1,2.6-0.3,6.7-0.5,10.6l28.4,2.6c-0.3-12-0.8-32-1.6-34.7C39.2,37.5,38.9,27.3,39.8,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107_",
    className: "st49",
    d: "M10.9,42l-2.5,0.8c0,0-4.3,3.1-7.4,3.5c-3.1,0.4,1.7,1.6,4.6,0c0,0-3.2,3.5,5.3-1.1v-2.3 l-2.5-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108_",
    className: "st49",
    d: "M48.1,38.6l2.3,1.3c0,0,3.6,3.9,6.5,5c2.9,1.1-2,1.2-4.5-0.9c0,0,2.4,4.1-5-2.2l0.5-2.3 l2.5,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109_",
    className: "st27",
    d: "M20.5,24.1c0,0,1.3,8.8-2.6,13.7s-7.4,8.2-7.4,8.2L8,42.8l7.9-10.3l-0.2-7.7L20.5,24.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110_",
    className: "st27",
    d: "M37.4,13.1c0,0-1.9,3.8,0.2,11.6c2,7.9,4.8,14.3,10.7,18.6l2.5-3c0,0-5.9-8.2-7.1-11 c-1.2-2.8-3.4-14.5-3.4-14.5L37.4,13.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111_",
    className: "st8",
    d: "M34.3-6.6c0,0,7.5,4.8,3.2,17.2c0,0,4,0.8,2.9,3.4c-1.1,2.6-2.6,5.6-3,11 c-0.3,5.5-1.3,9.1-3.8,12.8c0,0-5.5-0.4-8.2-3.4c-2.7-3-5.4-6.6-5.4-6.6s-4.5-0.6-5.6-1.8c0,0-0.1-7.8,0.7-9.6 c0.8-1.8,4.9-9.1,5.6-15.3C21.4-5,24.2-10.9,34.3-6.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_18_",
    className: "st49",
    cx: 28.6,
    cy: 0.6,
    rx: 5.5,
    ry: 7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112_",
    className: "st50",
    d: "M26.5,4.2c0,0,1.8-0.4,3,0c0,0,0.1,1.6-1.3,1.6C26.8,5.8,26.5,4.8,26.5,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113_",
    className: "st27",
    d: "M23.5-1.6c0,0,1.9-2,5.6-1.2s4.5,3.3,4.8,5.6c0,0,1.6-4.8-1.7-7.6S25.3-7.5,23.5-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114_",
    className: "st51",
    d: "M35.5,17.8c0,0-5,15.7-11-1.3c0,0-3.4-11.6-3-16.8c0,0,2.3,20.8,8.4,23.5 C29.9,23.2,32,25.1,35.5,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115_",
    className: "st51",
    d: "M19.7,7.1c0,0-1.3,14,0,17.7V7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116_",
    className: "st51",
    d: "M30.7,30.1c0,0-3.8,1.9-11.3-15.2C19.4,14.9,26,28.9,30.7,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117_",
    className: "st51",
    d: "M27.5,25.5c0,0-5.4-3.5-8.1-10.6C19.4,14.9,25.3,25,27.5,25.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_118_",
    transform: "translate(23.171610, 1.455001)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M17.1,12.5c-0.2-0.4-0.6-0.7-0.9-0.9c-0.4-0.2-0.8-0.3-1.2-0.4C14,11,13.2,11,12.3,11 c-0.4,0-0.9,0.1-1.3,0.1s-0.9,0.1-1.3,0.2c-0.9,0.1-1.8,0.1-2.7-0.3c-1.8-0.6-3.2-1.8-4.3-3.2C1.4,6.3,0.6,4.7,0,3l0,0l0,0 c0.8,1.6,1.7,3.2,2.8,4.6c1.1,1.3,2.5,2.6,4.1,3.2c0.8,0.3,1.7,0.4,2.6,0.3c0.4-0.1,0.9-0.1,1.3-0.2c0.4,0,0.9-0.1,1.3-0.1 c0.9,0,1.8,0.1,2.7,0.3c0.4,0.1,0.9,0.3,1.3,0.5C16.6,11.8,17,12.1,17.1,12.5C17.2,12.5,17.2,12.5,17.1,12.5 C17.2,12.5,17.2,12.5,17.1,12.5L17.1,12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M11.1-8c0.6,1.7,1.1,3.3,1.4,5.1s0.6,3.5,0.6,5.2c0,1.8-0.2,3.6-0.9,5.2c-0.4,0.8-0.8,1.6-1.4,2.2 c-0.6,0.6-1.4,1.1-2.2,1.5l0,0l0,0c0.7-0.4,1.4-1,2-1.7c0.6-0.7,0.9-1.4,1.3-2.2c0.6-1.6,0.9-3.3,0.9-5.1 c0-1.7-0.2-3.5-0.4-5.2C12-4.7,11.6-6.4,11.1-8C11-8,11.1-8.1,11.1-8C11.1-8.1,11.1-8.1,11.1-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M3.8,8.8C5,8.6,6.1,8.1,7.1,7.5c1.1-0.6,2-1.3,2.8-2.2c0.4-0.4,0.7-0.9,1.1-1.4 c0.3-0.6,0.6-1.1,0.8-1.6c0.3-0.6,0.4-1.1,0.6-1.7c0.1-0.3,0.1-0.6,0.2-0.9s0.1-0.6,0.2-0.9l0,0l0,0l0,0c0,0.6,0,1.2-0.1,1.8 c-0.1,0.6-0.2,1.2-0.4,1.8c-0.1,0.3-0.2,0.6-0.3,0.8L11.3,4c-0.4,0.5-0.7,1-1.2,1.4c-0.8,0.9-1.8,1.6-3,2.2 C6.2,8.2,5,8.7,3.8,8.8L3.8,8.8L3.8,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M5.3,10C5.9,9.9,6.5,9.7,7,9.5s1.1-0.4,1.6-0.8C9.1,8.4,9.6,8,10,7.6c0.4-0.4,0.7-0.9,0.9-1.5l0,0l0,0 c-0.1,0.6-0.3,1.2-0.7,1.7C9.9,8.3,9.3,8.7,8.8,9C7.7,9.6,6.5,10,5.3,10C5.3,10.1,5.3,10.1,5.3,10C5.3,10.1,5.3,10,5.3,10z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_119_",
    className: "st51",
    d: "M35.9,12.5c-0.1,0-0.1-0.1-0.1-0.1c-0.1-0.1,0-0.2,0.1-0.2c1.3-0.6,1.4-1.6,1.4-1.6 s0.1-0.1,0.2-0.1c0.1,0,0.1,0.1,0.1,0.2C37.6,10.6,37.4,11.8,35.9,12.5C35.9,12.5,35.9,12.5,35.9,12.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_19_",
    className: "st27",
    cx: 25.7,
    cy: 0,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_20_",
    className: "st27",
    cx: 30.1,
    cy: 0,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120_",
    className: "st52",
    d: "M27.6,2.9L27.6,2.9C27.3,2.9,27,2.8,27,2.6c-0.2-0.4,0.2-1.1,0.2-1.1l0.4-1.3 c0-0.1,0.1-0.1,0.1-0.1s0.1,0.1,0.1,0.1l-0.4,1.3c0,0-0.4,0.6-0.2,1c0.1,0.2,0.3,0.3,0.6,0.3c0.1,0,0.1,0.1,0.1,0.1 C27.7,2.9,27.7,2.9,27.6,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121_",
    className: "st52",
    d: "M31.8-0.6C31.8-0.6,31.7-0.6,31.8-0.6c-0.9-1.7-2.8-0.7-2.9-0.7c-0.1,0-0.1,0-0.1-0.1 c0-0.1,0-0.1,0.1-0.1c0,0,2.1-1,3,0.7C31.8-0.6,31.8-0.6,31.8-0.6L31.8-0.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122_",
    className: "st52",
    d: "M24-1C24-1,24-1.1,24-1C24-1.1,24-1.1,24-1.1s0.6-0.7,1.4-0.8C25.9-2,26.5-1.7,27-1.1 c0,0,0,0.1,0,0.1c0,0-0.1,0-0.1,0c-0.5-0.5-1.1-0.8-1.6-0.7C24.6-1.7,24.1-1,24-1C24.1-1.1,24.1-1,24-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123_",
    className: "st53",
    d: "M19.1,40.8c0,0-3.4,21.1,4.2,25.8C31,71.3,17,63.9,19.1,40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124_",
    className: "st53",
    d: "M17.7,74l3.1,0.3c-2-2.1-3.5-4.6-4.2-7.9C16.6,66.4,15.8,70.2,17.7,74z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125_",
    className: "st53",
    d: "M37.4,37.8c0,0,1.1,5.5-3.5,11.5C33.9,49.4,40.3,46.3,37.4,37.8z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyGallery);
export default __webpack_public_path__ + "static/media/empty-gallery.8f7a044caca587ba8bcabe34603e8b66.svg";
export { ForwardRef as ReactComponent };